import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import auth from './utils/auth';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Announcements from './pages/Announcements';
import Team from './pages/Team';
import Blog from './pages/Blog';
import Consultations from './pages/Consultations';
import Locations from './pages/Locations';
import Users from './pages/Users';
import NewsJudgments from './pages/NewsJudgments';

// Protected Route Component
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  if (!auth.isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
};

// Role-based Protected Route Component
const RoleProtectedRoute: React.FC<{ children: React.ReactNode; allowedRoles: string[] }> = ({ children, allowedRoles }) => {
  if (!auth.isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  const user = auth.getUser();
  if (!user || !allowedRoles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
};

function App() {
  return (
    <div className="antialiased" dir="rtl" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <BrowserRouter>
        <div style={{ flex: 1 }}>
          <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/announcements"
          element={
            <RoleProtectedRoute allowedRoles={['dashboard_admin', 'super_admin']}>
              <Announcements />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/team"
          element={
            <RoleProtectedRoute allowedRoles={['dashboard_admin', 'super_admin']}>
              <Team />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/blog"
          element={
            <RoleProtectedRoute allowedRoles={['dashboard_admin', 'super_admin']}>
              <Blog />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/news-judgments"
          element={
            <RoleProtectedRoute allowedRoles={['dashboard_admin', 'super_admin']}>
              <NewsJudgments />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/consultations"
          element={
            <RoleProtectedRoute allowedRoles={['dashboard_admin', 'super_admin']}>
              <Consultations />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/locations"
          element={
            <RoleProtectedRoute allowedRoles={['dashboard_admin', 'super_admin']}>
              <Locations />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <RoleProtectedRoute allowedRoles={['super_admin']}>
              <Users />
            </RoleProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>
        <footer
          style={{
            padding: '12px 24px',
            textAlign: 'center',
            fontSize: '14px',
            color: 'var(--text-secondary, #64748b)',
            backgroundColor: 'var(--background-paper, #f8fafc)',
            borderTop: '1px solid var(--border-color, #e2e8f0)',
          }}
        >
          Developed by{' '}
          <a
            href="https://www.reverso-ds.com/en"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'var(--primary, #477CD7)', textDecoration: 'none' }}
          >
            Reverso-DS
          </a>
        </footer>
      </BrowserRouter>
    </div>
  );
}

export default App;
